//import Oauth from "@/pages/bocom/oauth.vue"
import { authorizeBocomCode } from "@/utils/bocom"
import { defineStore } from "pinia"



export const useClientStore = defineStore(
    "client", {
    state: () => {
        return {
            client: uni.getStorageSync('client') || null
        }
    },
    actions: {
        setClient(client: string) {
            this.client = client
            uni.setStorageSync('client', client)
        },
        getClient() {
            return this.client
        },
        clearClient() {
            this.client = null
            uni.removeStorageSync('client')
        },

        oauth(url: string, state?: string) {
            if (
                this.client === "bocom"
            ) {
                authorizeBocomCode(url ? window.location.origin + url : window.location.href, state)
            }
        }
    }
}
)